import { useState } from "react"
import { CardGroup, Card, Image, Modal, Button } from "react-bootstrap"
import "react-multi-carousel/lib/styles.css"

interface IActivity {
  image: string
  topic: string
  detail?: any[]
  date: string
  fbId: string
}

export const CardActivity = () => {
  const activity: IActivity[] = [
    {
      image: "https://scontent.fbkk5-7.fna.fbcdn.net/v/t39.30808-6/329080242_1121299101808681_93807834220617989_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeE_L9U8ahcSH9B5MBCMWPZb0ZQydZ-5nF7RlDJ1n7mcXq-8bimYfeYmWBvBg1fwTru5SvG2LEQ6zvOQ9B0cdePN&_nc_ohc=iPhJiT9xgdgAX9G7iZV&_nc_oc=AQk1Dd85tZgf23Yg0iQu4PwdkxjKByliDRgm5fIid2-sjNthCRUiwazvJnoYEeTKrwQ&_nc_ht=scontent.fbkk5-7.fna&oh=00_AfBvzEKgOZ_9YRWadMNfqgsijxpplDN0BRY4vxkBAMvFrw&oe=64848A46",
      topic:
        "หน่วยแพทย์อาสาเฉพาะทาง ในพื้นที่ห่างไกล 'มูลนิธิโรงพยาบาลนครพิงค์' มอบโอกาสเข้าถึงการรักษาโดยแพทย์เฉพาะทางให้กับผู้ที่อยู่ห่างไกล",
      fbId: "121076224218150",
      date: "24-25 ธันวาคม 2565",
    },
    {
      image: "https://scontent.fbkk5-1.fna.fbcdn.net/v/t39.30808-6/331915912_899215501202007_7028149080420673846_n.jpg?stp=cp6_dst-jpg&_nc_cat=109&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeF0pYMI6fbNJuuwi428FuaOGAkwjFkwdDMYCTCMWTB0M2cHaGbmTzx1j1FYfNTGuSUwbIkDch8QyM5DaQ6lY8ca&_nc_ohc=en4H9dhxoDwAX9kPP2J&_nc_ht=scontent.fbkk5-1.fna&oh=00_AfCw1Dpa26IB4K_GLDyrGnhYhvd4sut4-QXc5aydjrsYzw&oe=648564E4",
      topic:
        "ตรวจคัดกรองโรคหัวใจด้วย Echocardiogram ให้กับประชาชนในพื้นที่ห่างไกล",
      fbId: "127547746904331",
      date: "13-14 มกราคม 2566",
    },
    {
      image: "https://scontent.fbkk29-1.fna.fbcdn.net/v/t39.30808-6/330012791_683598523456035_4250789385340441688_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeHaSg8PqBpGtUazX777IMM3bNGrvq6LjwBs0au-rouPAEKu_XMaRH9RA4_iOFpE5GsDNLFvvtp-G2KNr0Q18a_H&_nc_ohc=bLG9KaflW98AX8K-4mA&_nc_ht=scontent.fbkk29-1.fna&oh=00_AfAKySUaGUw4T71pbFb8HlfXFZtGDh2v9iHm7AimsX7-lA&oe=6484858D",
      topic:
        "จัดพิธีทำบุญเปิดสำนักงานมูลนิธิโรงพยาบาลนครพิงค์แห่งใหม่",
      fbId: "123258743999898",
      date: "9 กุมภาพันธ์ 2566",
    },
    {
      image: "https://scontent.fbkk5-7.fna.fbcdn.net/v/t39.30808-6/337999566_722586062686302_7091104132714977740_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeHpVMB173vakbZ-b1sJXBGBxQGiCPUt0qbFAaII9S3SpqDCqj3z-AmTMIr9DYZwTYb6cbc7hCndcsPmqiMN2nI0&_nc_ohc=6VAbpwz9oTkAX9bCKo0&_nc_ht=scontent.fbkk5-7.fna&oh=00_AfCQqKm6w3KmeMNHN0K1pEAuaitq1ou7Qh1Wp3FYs998iQ&oe=648577AE",
      topic:
        "หน่วยแพทย์อาสามูลนิธิโรงพยาบาลนครพิงค์ ผ่าตัดโรคระบบทางเดินปัสสาวะเพื่อผู้ป่วยใน จ.แม่ฮ่องสอน",
      fbId: "152289474430158",
      date: "24-26 มีนาคม 2566",
    },
    {
      image: "https://scontent.fbkk5-4.fna.fbcdn.net/v/t39.30808-6/352138532_139998245755738_5163289577372581276_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeE6Y5e5i1zXQAwfpWtNA_TzY_RRXvVHtINj9FFe9Ue0gxVpMf7xkyPr1fAo-JWzny-9Mcqy8wkRZcSJTZLOQ9a7&_nc_ohc=qiGWs0oeQa4AX9U6Vf8&_nc_ht=scontent.fbkk5-4.fna&oh=00_AfBd6LLX8r4YWZc4uXFcXa85Nc6x1FCTMoatggEHZx8CLg&oe=648532CB",
      topic:
        "ออกหน่วยอาสาตรวจคัดกรองโรคหัวใจด้วย Echocardiogram ในพื้นที่ จ.แม่ฮ่องสอน",
      fbId: "200462376279534",
      date: "2-4 มิถุนายน 2566",
    }
  ]
  // const responsive = {
  //   desktop: {
  //     breakpoint: { max: 3000, min: 1024 },
  //     items: 5,
  //   },
  //   tablet: {
  //     breakpoint: { max: 1024, min: 464 },
  //     items: 3,
  //   },
  //   mobile: {
  //     breakpoint: { max: 464, min: 0 },
  //     items: 1,
  //   },
  // }
  const [detail, setdetail] = useState<IActivity | null>(null)
  const [openDetail, setopenDetail] = useState<boolean>(false)
  const closeDetail = () => {
    setdetail(null)
    setopenDetail(false)
  }
  const [width, setwidth] = useState<number | null>(null)
  return (
    // <div className="wrapper" key={value.image}>
    //   <div className="media">
    //     <div className="layer">
    //       <div style={{ padding: "1em" }}>
    //         <p>{value.topic}</p>
    //         <div className="text-center">
    //           <Button>อ่านต่อ</Button>
    //         </div>
    //       </div>
    //     </div>
    //     <Image
    //       width={"100%"}
    //       loading="lazy"
    //       fluid
    //       src={`images/image-activity-${value.image}-600xauto.jpg`}
    //       alt={value.image}
    //     />
    //   </div>
    //   <Card.Footer
    //     className="text-center mb-4"
    //     style={{ backgroundColor: "gray" }}
    //   >
    //     {value.date}
    //   </Card.Footer>
    // </div>
    <div className="card-custom">
      {/* <Carousel
        swipeable={true}
        draggable={true}
        showDots={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={10000}
        arrows={true}
      > */}
      <CardGroup>
        {activity
          .reverse()
          .map((value) => (
            <Card key={value.image} className="shadow-drop-tb">
              <Card.Img
                variant="top"
                src={value.image}
              />
              <Card.Footer>
                <small className="text-muted">📅 {value.date}</small>
              </Card.Footer>
              <Card.Body>
                <Card.Title>{value.topic}</Card.Title>
                <div className="text-center">
                  <span
                    onClick={() => {
                      setdetail(value)
                      setopenDetail(true)
                    }}
                    className="btnNews"
                  >
                    อ่านต่อ
                    <img alt={value.image} src="images/icon-right.png" />
                  </span>
                </div>
              </Card.Body>
            </Card>
          ))}
      </CardGroup>
      {/* </Carousel> */}
      <Modal show={openDetail} onHide={closeDetail} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>รายละเอียดข่าวสาร</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            ref={(el: any) => {
              if (el) {
                setwidth(el.offsetWidth)
              }
            }}
            style={{ width: "100%" }}
          ></div>
          {detail?.fbId === "" ? (
            <>
              <h5 style={{ fontWeight: "bold" }}>{detail?.topic}</h5>
              <Image
                width={"100%"}
                className="mb-3 mt-3"
                fluid
                src={`images/image-activity-${detail?.image}-600xauto.jpg`}
              />
            </>
          ) : (
            <></>
          )}
          {detail?.detail?.map((value, index1) => {
            return (
              <div key={index1}>
                {typeof value === "string" ? (
                  <p key={index1}>{value}</p>
                ) : (
                  <ul>
                    {Array(value).map((value: string, index2) => (
                      <li key={index2}>{value}</li>
                    ))}
                  </ul>
                )}
              </div>
            )
          })}
          {width ? (
            <div>
              <iframe
                src={`https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FNakornpingHospitalChiangmai%2Fposts%2F${detail?.fbId}&width=${width}&show_text=true&appId=184500590217759&height=${window.innerHeight}`}
                width={width}
                height={window.innerHeight}
                style={{ border: "none", overflow: "hidden" }}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title="page-box"
              ></iframe>{" "}
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeDetail}>
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
